enum ECustomerServiceResponse {
    CustomerNotFound = 2100
}

export default ECustomerServiceResponse;
